import { Form } from "react-bootstrap";
import { useRoleContext } from "../Providers/RoleProvider";

const NewDynamicText = ({
  value = "",
  valueKey = "",
  isUpdated = false,
  isRequired = false,
  onChange,
  inputWidth = 85,
}) => {
  const { isAdmin } = useRoleContext();
  const requiredCheck = isRequired && !value;

  const handleChange = (e) => {
    let val = e.target.value;

    if (
      valueKey === "portBandwidthConverted" ||
      valueKey === "accessBandwidthConverted"
    ) {
      val = val.replace(/\D/g, "");
      if (val.length > 10) val = val.slice(0, 10);
      val = Number(val);
    }

    onChange({
      key: valueKey,
      value: val,
    });
  };

  return (
    <Form.Control
      type="text"
      disabled={!isAdmin}
      value={value}
      style={{ width: `${inputWidth}%` }}
      className={`mt-1 text-input ${
        isUpdated ? "updated" : requiredCheck ? "required" : ""
      }`}
      onChange={handleChange}
    />
  );
};

export default NewDynamicText;
